module.exports = require('./clinicadmin');
